export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  periodicidade: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  periodicidadeDias: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  exibirEmDiversos: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  exibirEmViagemAdm: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  exibirEmReembolsoGeral: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  descricao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/travelreason/travelreason-form.js